import { Alert } from '@mui/material';

import { FC } from 'react';

interface HardcodedBannerProps {
  sponsorPlanId: number;
}

export const HardcodedBanner: FC<HardcodedBannerProps> = ({
  sponsorPlanId
}) => {
  return (
    <>
      {[504713].includes(sponsorPlanId) && (
        <Alert severity='error'>
          This plan is highly sensitive and high priority to J.P. Morgan. If
          this plan reaches out to us, please direct comms first to
          naomi.olsen@jpmchase.com, william.p.reynolds@jpmorgan.com, and
          jpmsales@vestwell.com before responding to the client
        </Alert>
      )}
      {[431, 6335].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Cash Balance Plan - please consult with ECS on all testing related
          questions and actions
        </Alert>
      )}
      {[186, 104].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Cash Balance Plan (Ref. Plan ID {sponsorPlanId === 104 ? 6335 : 431})
          - please consult with ECS on all testing related questions and actions
        </Alert>
      )}
      {[5060].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Due to various circumstances involving this plan, the servicing team
          should not engage with any participant or plan sponsor (or anyone
          calling on their behalf) before informing Legal.
        </Alert>
      )}
      {[
        503891, 447, 245927, 450, 4880, 327393, 504736, 246533, 70458, 355, 6401
      ].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this is a Top Tier Client, please loop in Pete Naquin,
          Account Manager, for any plan updates or issues.
        </Alert>
      )}
      {[445, 331373, 242, 331208].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this is a Top Tier Client, please loop in Ro Wilson,
          Account Manager, for any plan updates or issues.
        </Alert>
      )}
      {[562538].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this plan is covered by the same plan documents as Plan
          ID: 596134, but was split to accommodate payroll integration. Please
          loop in Pete Naquin, Account Manager, for any plan updates or issues.
        </Alert>
      )}
      {[596134].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this plan is covered by the same plan documents as Plan
          ID: 562538, but was split to accommodate payroll integration. Please
          loop in Pete Naquin, Account Manager, for any plan updates or issues.
        </Alert>
      )}
      {[543797].includes(sponsorPlanId) && (
        <Alert severity='error'>Add DORH dates to PS2-19952</Alert>
      )}
      {[332893].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please direct all inquires for this plan to Alyssa Morales or Olivia
          Peters
        </Alert>
      )}
      {[363406, 475123, 363404].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Vestwell has terminated Fiduciary service for this plan, Vestwell to
          only provide recordkeeping services.
        </Alert>
      )}
      {[331361].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Vestwell has terminated fiduciary services for this plan. All
          compliance testing, forms, and filings should be completed by the
          sponsor. Please connect with ES for additional details.
        </Alert>
      )}
      {[601829, 604948, 647069].includes(sponsorPlanId) && (
        <Alert severity='error'>
          There is potentially suspicious activity on this account. No changes
          should be made to this account at this time. Please escalate any
          requests related to this account to the Legal and Compliance teams.
        </Alert>
      )}
      {[169576].includes(sponsorPlanId) && (
        <Alert severity='error'>
          This plan has been escalated by the advisor. No emails are to be sent
          to employees and any emails from employees are to be escalated to the
          advisor. No changes should be made to this account without approval
          from the advisor. Please notify the legal and compliance team of any
          unauthorized activity.
        </Alert>
      )}
      {[574357].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this plan is covered by the same plan documents as Plan
          ID: [610641], but was split to accommodate payroll integration. Please
          loop in Sara Pearson for any plan updates or issues.
        </Alert>
      )}
      {[610641].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this plan is covered by the same plan documents as Plan
          ID: [574357], but was split to accommodate payroll integration. Please
          loop in Sara Pearson for any plan updates or issues.
        </Alert>
      )}
      {[573290].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this plan is covered by the same plan documents as Plan
          ID: 573289, but was split to accommodate payroll integration.
        </Alert>
      )}
      {[573289].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this plan is covered by the same plan documents as Plan
          ID: 573290, but was split to accommodate payroll integration.
        </Alert>
      )}
      {[638160, 638161, 638162].includes(sponsorPlanId) && (
        <Alert severity='error'>
          Please note this plan is covered by the same plan documents as Plan
          ID: 598810, but was split to accommodate payroll integration.
        </Alert>
      )}
    </>
  );
};
